export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const afterSanitizeAttributes = currentNode => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

// Restrict iframes to trusted providers (YouTube embeds only)
export const uponSanitizeElement = (node, data) => {
  if (data.tagName && data.tagName.toLowerCase() === 'iframe') {
    const src = node.getAttribute('src') || '';
    const isYouTube =
      /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//i.test(src) ||
      /^https?:\/\/www\.youtube\.com\/embed\//i.test(src) ||
      /^https?:\/\/www\.youtube-nocookie\.com\/embed\//i.test(src);
    if (!isYouTube) {
      // Drop non-YouTube iframes entirely
      node.parentNode && node.parentNode.removeChild(node);
    } else {
      // Enforce a safe baseline of attributes
      node.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      node.setAttribute('allowfullscreen', '');
      node.setAttribute('loading', 'lazy');
      node.setAttribute('frameborder', '0');
    }
  }
};

export const domPurifyConfig = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: [
    'allow',
    'allowfullscreen',
    'frameborder',
    'scrolling',
    'src',
    'height',
    'width',
    'loading',
  ],
  hooks: {
    afterSanitizeAttributes,
    uponSanitizeElement,
  },
};
